import React from 'react';
import AccessMethodForm from '../../../components/Enrollment/AccessMethod/AccessMethodForm';
import { AccessMethodType } from '../../../components/Enrollment/AccessMethod/AccessMethodFormData';
import { useEnrollment } from '../../../context/Enrollment/EnrollmentContext';
import { getFormDataByType, getTypeByFormData } from '../utils/AccessMethodUtils';
import { EnrollmentData } from '../EnrollmentData';

const AccessMethod = (): JSX.Element => {
  const { enrollmentData, setEnrollmentData, nextPage } = useEnrollment();
  function onSubmit({ accessMethod }: { accessMethod: AccessMethodType }) {
    const accessMethodFormData = getFormDataByType(accessMethod);
    setEnrollmentData((prevState: EnrollmentData) => {
      const previousType = prevState.accessMethodFormData?.type;
      const newType = accessMethodFormData?.type;

      // If the user reselects an access method with the same account _type_ they had previously selected,
      // keep the previously submitted enrollment data.
      // This includes if the user previously selected "Employer" and changes to "Web Services - Employer" and vice-versa,
      // or "Employer Agent" to "Web Services - Employer Agent" and vice-versa.
      if (previousType === newType) {
        return {
          ...prevState,
          accessMethodFormData,
        };
      }
      // Otherwise, reset the enrollment data to only the selected access method.
      return {
        enrollmentType: prevState.enrollmentType,
        accessMethodFormData,
        defaultHiringSiteCreated: false,
      };
    });

    nextPage();
  }

  const selectedAccessMethod = getTypeByFormData(enrollmentData.accessMethodFormData);

  return (
    <AccessMethodForm
      onSubmit={onSubmit}
      accessMethod={selectedAccessMethod}
      enrollmentType={enrollmentData.enrollmentType}
    />
  );
};

export default AccessMethod;
